import React, { useState, useEffect, useRef, useContext } from "react";
import "./CustomSelect.css";
import { UserContext } from "context";
import { RxCross2 } from "react-icons/rx";
import { FiEdit } from "react-icons/fi";
import InfiniteScroll from "react-infinite-scroll-component";

const CustomSelect = ({
  name,
  options,
  onSelect,
  placeholder,
  value,
  error,
  focus,
  error_class = "",
  id = Math.random() * 1000,
  multi = false, 
  label,
  flotingLabel,
  disabled,
  isAddButton,
  addButtonAction,
  dynamicIndex,
  tableIndex,
  field,
  isDropdownTop,
  openList = true,
  disableSearch = false,
  labelRedStar = false,
  isClearOption = false,
  isClearHandleChange,
  onEdit,
  component_class = "",
  enableInfiniteScroll = false,
  fetchMoreData,
  hasMore,
  errorShow = true,
  optionShowCityState = false,
  isCityAddressCode = false,
  setSearchValue = () => {},
  searchValue = "",
  onMenuOpen, // 🎯 New prop for lazy loading
  isLoading = false, // 🎯 New prop for loading state
  onEditValue = null,
}) => {
  const { masterData } = useContext(UserContext);
  const invalid = !!(focus && error);
  const valid = !!Boolean(focus && !error);
  const [searchQuery, setSearchQuery] = useState(value ? value : options[0]?.label || "");
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredOptions, setFilteredOptions] = useState(options?.length ? options : []);
  const [selectedValue, setSelectedValue] = useState(multi ? value || [] : value || null);
  const dropdownRef = useRef(null);
  const hasCalledOnMenuOpen = useRef(false); // Track if onMenuOpen was called

  useEffect(() => {
    if (value) {
      setSelectedValue(value);
    }
    setSearchQuery("");
  }, [value]);

  useEffect(() => {
    setFilteredOptions(
      options?.filter(
        (option) =>
          typeof searchQuery === "string" &&
          option?.label?.toLowerCase()?.includes(searchQuery.toLowerCase())
      )
    );
  }, [searchQuery, options]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
        hasCalledOnMenuOpen.current = false; // Reset when dropdown closes
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleInputChange = (e) => {
    const inputValue = e.target.value.toString();
    setSearchQuery(inputValue);
    setSearchValue(inputValue);
    setShowDropdown(true);
  };

  const handleOptionClick = (option, index, label, tableIndex, field) => {
    if (multi) {
      setSelectedValue((prev) => {
        const alreadySelected = prev.some((item) => item._id === option._id);
        const updatedSelection = alreadySelected
          ? prev.filter((item) => item._id !== option._id)
          : [...prev, option];

        if (onSelect) onSelect(updatedSelection);
        return updatedSelection;
      });
    } else {
      onSelect(option, index, label, tableIndex, field);
      setSearchQuery("");
      setShowDropdown(false);
      hasCalledOnMenuOpen.current = false; // Reset for next open
    }
  };

  const handleRemoveValue = (option) => {
    const updatedSelection = selectedValue.filter((item) => item.value !== option.value);
    setSelectedValue(updatedSelection);
    if (onSelect) onSelect(updatedSelection);
  };

  const handleRestectChange = (e) => {
    setSelectedValue(selectedValue);
  };

  const handleaddButtonAction = (e) => {
    setShowDropdown(false);
    addButtonAction(error_class);
  };

  // 🎯 Handle dropdown toggle with lazy loading
  const handleDropdownToggle = () => {
    const newShowDropdown = !showDropdown;
    setShowDropdown(newShowDropdown);
    
    // Call onMenuOpen only once when dropdown opens
    if (newShowDropdown && onMenuOpen && !hasCalledOnMenuOpen.current) {
      hasCalledOnMenuOpen.current = true;
      onMenuOpen();
    }
  };

  useEffect(() => {
    if (id) {
      const element = document && document?.getElementById(id);

      const handleMouseDown = (e) => {
        if (e?.detail > 1) {
          e?.preventDefault();
        }
      };

      if (element) {
        element.addEventListener("mousedown", handleMouseDown);
      }

      return () => {
        if (element) {
          element.removeEventListener("mousedown", handleMouseDown);
        }
      };
    }
  }, [id]);

  const reqfetchMoreData = () => {
    fetchMoreData();
  };

  const valueFunction = () => {
    if (selectedValue.code || selectedValue.label || selectedValue?.city?.label) {
      return [selectedValue.label, selectedValue?.city?.label].filter(Boolean).join(" | ");
    }
    return '';
  };

  return (
    <div
      // className={
      //   error
      //     ? "custom-select-container custom-select_eror"
      //     : "custom-select-container"
      // }

      className={`custom-select-container ${error ? "custom-select_eror" : ""} ${onEditValue ? "_editValueBrx" : ""}`} ref={dropdownRef} >
      <div className="input-wrapper">
        <input
          id={id}
          type="text"
          placeholder={placeholder}
          value={
            multi
              ? selectedValue?.map((val) => val.name).join(" | ")
              : isCityAddressCode ? valueFunction() : (selectedValue?.label || '')
          }
          name={name}
          onChange={handleRestectChange}
          readOnly={true}
          disabled={disabled}
          index={dynamicIndex}
          onClick={handleDropdownToggle} // 🎯 Use new handler
        />
        {(isClearOption && selectedValue?.label != "All" && selectedValue?.value != "" && selectedValue?.value != null) && (
          <span className="clear-icon" onClick={isClearHandleChange}>
            <RxCross2 size={20} color="black" />
          </span>
        )}

        {(selectedValue?.value && onEditValue) && ( <div className="__editFloatIcon"> <span className="_cty_icon_divider" /> <span className="_cty_edit_icon" title="Edit" 
        onClick={(e) => { e.stopPropagation(); onEditValue(selectedValue); }} > <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" > <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /> <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" /> </svg> </span> </div> )}
        
      </div>
      <label className="_fltLabel">
        <span>
          {label ? label : flotingLabel}
          {labelRedStar && <span className="requiredLable"> * </span>}
        </span>
      </label>

      {showDropdown && (
        <React.Fragment>
          {openList && (
            <ul
              className={
                isDropdownTop
                  ? "custom-dropdown-menu cus-topDrop"
                  : "custom-dropdown-menu"
              }
            >
              {!disableSearch && (
                <li onClick={handleDropdownToggle}>
                  <div
                    className="dropSearch_bx"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <input
                      type="text"
                      placeholder="Search"
                      onChange={handleInputChange}
                      autoFocus={true}
                      value={searchQuery || ""}
                    />
                  </div>
                </li>
              )}
              
              <li className="mapList_views">
                {/* 🎯 Show loading state */}
                {isLoading ? (
                  <div style={{ padding: '20px', textAlign: 'center' }}>
                    <p>Loading...</p>
                  </div>
                ) : (filteredOptions.length > 4 && enableInfiniteScroll) ? (
                  <InfiniteScroll
                    dataLength={filteredOptions.length}
                    next={reqfetchMoreData}
                    hasMore={hasMore}
                    loader={<p className="text-center">Loading...</p>}
                    height={filteredOptions.length < 4 ? filteredOptions.length * 66 : 230}
                  >
                    <ul>
                      {filteredOptions?.length > 0 ? (
                        filteredOptions?.map((option, index) => (
                          <React.Fragment key={index}>
                            <li
                              className={`_anvRo_locateBx ${multi
                                ? selectedValue.some((val) => val._id === option._id)
                                  ? "_vhlActive"
                                  : ""
                                : selectedValue?.label === option?.label
                                  ? "_vhlActive"
                                  : ""
                                } ${(selectedValue?.value === option?.value && component_class === "vehicle_number_trip") ? '_vhlActive' : ''
                                }`}
                              key={`${option.value}_${index}`}
                              onClick={() =>
                                handleOptionClick(
                                  option,
                                  dynamicIndex,
                                  label,
                                  tableIndex,
                                  field
                                )
                              }
                            >
                              {label === "Vehicle Number" ? (
                                <React.Fragment>
                                  <div className="anvLrc ">
                                    <div className="_vhlNumber">{option.label}</div>
                                    <div className="_vhlOwnType">
                                      <span
                                        className={
                                          option?.vehicle_ownership == 1
                                            ? "_trkMark _lrDelivered_status"
                                            : option?.vehicle_ownership == 2
                                              ? "_trkMark _lrPartyPoint_status"
                                              : "_trkMark _lrInTransit_status"
                                        }
                                      >
                                        {masterData?.vehicle_ownership[option?.vehicle_ownership]}
                                      </span>
                                      {option.lorry_type_id?.lorry_type && option.vehicle_type_id_1?.name
                                        ? ` | ${option.lorry_type_id.lorry_type} ${option.vehicle_type_id_1.name}`
                                        : ''}
                                    </div>
                                  </div>
                                  <div className="_vhlStatus">
                                    <span className="available_status"></span>
                                    {`${masterData?.vehicle_status[option?.vehicle_status]}`}
                                  </div>
                                </React.Fragment>
                              ) : (
                                <div className="anvLrc_edit">
                                  <a>{option.label}</a>
                                  {onEdit && <div className="po_button_align">
                                    <button
                                      className="__edit_btn_po"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        onEdit(option);
                                      }}
                                    >
                                      <FiEdit />
                                    </button>
                                  </div>}
                                </div>
                              )}
                            </li>
                          </React.Fragment>
                        ))
                      ) : (
                        <li className="_anvRo_locateBx" style={{ fontSize: "13px" }}>
                          No Result Found
                        </li>
                      )}
                    </ul>
                  </InfiniteScroll>
                ) : (
                  <ul>
                    {filteredOptions?.length > 0 ? (
                      filteredOptions?.map((option, index) => (
                        <React.Fragment key={index}>
                          <li
                            className={`_anvRo_locateBx 
                              ${multi
                                ? selectedValue.some((val) => val._id === option._id)
                                  ? "_vhlActive"
                                  : ""
                                : selectedValue?.value === option.value
                                  ? "_vhlActive"
                                  : ""
                              }
                              ${(selectedValue?.value === option.value && component_class === "vehicle_number_trip") ? '_vhlActive' : ''}`
                            }
                            key={`${option.value}_${index}`}
                            onClick={() =>
                              handleOptionClick(
                                option,
                                dynamicIndex,
                                label,
                                tableIndex,
                                field
                              )
                            }
                          >
                            {label === "Vehicle Number" ? (
                              <React.Fragment>
                                <div className="anvLrc ">
                                  <div className="_vhlNumber">{option.label}</div>
                                  <div className="_vhlOwnType">
                                    <span
                                      className={
                                        option?.vehicle_ownership == 1
                                          ? "_trkMark _lrDelivered_status"
                                          : option?.vehicle_ownership == 2
                                            ? "_trkMark _lrPartyPoint_status"
                                            : "_trkMark _lrInTransit_status"
                                      }
                                    >
                                      {masterData?.vehicle_ownership[option?.vehicle_ownership]}
                                    </span>
                                    {` | ${option.lorry_type_id?.lorry_type} ${option.vehicle_type_id_1?.name}`}
                                  </div>
                                </div>
                                <div className="_vhlStatus">
                                  <span className="available_status"></span>
                                  {`${masterData?.vehicle_status[option?.vehicle_status]}`}
                                </div>
                              </React.Fragment>
                            ) : (
                              <div className="anvLrc_edit">
                                <a>{optionShowCityState ? option.cityStateLabel : option.label}</a>
                                {onEdit && <div className="po_button_align">
                                  <button
                                    className="__edit_btn_po"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      onEdit(option);
                                    }}
                                  >
                                    <FiEdit />
                                  </button>
                                </div>}
                              </div>
                            )}
                          </li>
                        </React.Fragment>
                      ))
                    ) : (
                      <li className="_anvRo_locateBx" style={{ fontSize: "13px" }}>
                        No Result Found
                      </li>
                    )}
                  </ul>
                )}
              </li>
              
              {isAddButton && (
                <li className="mt-1 _lineDrp anvLrc">
                  <button
                    className="_addNew_cdmBtn"
                    onClick={handleaddButtonAction}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 18 18"
                      fill="none"
                    >
                      <path
                        d="M8.61539 0C6.33902 0.0276205 4.16368 0.944178 2.55393 2.55393C0.944178 4.16368 0.0276205 6.33902 0 8.61539C0.0276205 10.8917 0.944178 13.0671 2.55393 14.6768C4.16368 16.2866 6.33902 17.2031 8.61539 17.2308C10.8917 17.2031 13.0671 16.2866 14.6768 14.6768C16.2866 13.0671 17.2031 10.8917 17.2308 8.61539C17.2031 6.33902 16.2866 4.16368 14.6768 2.55393C13.0671 0.944178 10.8917 0.0276205 8.61539 0ZM13.5385 9.23077H9.23077V13.5385H8V9.23077H3.69231V8H8V3.69231H9.23077V8H13.5385V9.23077Z"
                        fill="#1956F6"
                      />
                    </svg>
                    Add New
                  </button>
                </li>
              )}
            </ul>
          )}
        </React.Fragment>
      )}

      {errorShow && (
        <>
          {error && (
            <span className={"input_drop_error" + error_class}>{error}</span>
          )}
        </>
      )}
    </div>
  );
};

export default CustomSelect;

// import React, { useState, useEffect, useRef, useContext } from "react";
// import "./CustomSelect.css"; // Import the CSS file for styling
// import { UserContext } from "context";
// import { RxCross2 } from "react-icons/rx";
// import { IoPencilSharp } from "react-icons/io5";
// import { FiEdit } from "react-icons/fi";
// import InfiniteScroll from "react-infinite-scroll-component";

// const CustomSelect = ({
//   name,
//   options,
//   onSelect,
//   placeholder,
//   value,
//   error,
//   focus,
//   error_class = "",
//   id = Math.random() * 1000,
//   multi = false, 
//   label,
//   flotingLabel,
//   disabled,
//   isAddButton,
//   addButtonAction,
//   dynamicIndex,
//   tableIndex,
//   field,
//   isDropdownTop,
//   openList = true,
//   disableSearch = false,
//   labelRedStar = false,
//   isClearOption = false,
//   isClearHandleChange,
//   onEdit,
//   component_class = "",
//   enableInfiniteScroll = false,
//   fetchMoreData,
//   hasMore,
//   errorShow = true,
//   optionShowCityState = false,
//   isCityAddressCode = false,
//   setSearchValue=()=>{},
//   searchValue=""
// }) => {
//   const { masterData } = useContext(UserContext);
//   const invalid = !!(focus && error);
//   const valid = !!Boolean(focus && !error);
//   const [searchQuery, setSearchQuery] = useState(
//     value ? value : options[0]?.label || ""
//   );
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [filteredOptions, setFilteredOptions] = useState(options?.length ? options : []);
//   const [selectedValue, setSelectedValue] = useState(multi ? value || [] : value || null);
//   const dropdownRef = useRef(null);

//   useEffect(() => {
//     if (value) {
//       setSelectedValue(value);
//     }
//     setSearchQuery("");
//   }, [value]);

//   useEffect(() => {
//     setFilteredOptions(
//       options?.filter(
//         (option) =>
//           typeof searchQuery === "string" && // Check if searchQuery is a string
//           option?.label?.toLowerCase()?.includes(searchQuery.toLowerCase())
//       )
//     );
//   }, [searchQuery, options]);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowDropdown(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   const handleInputChange = (e) => {
//     const inputValue = e.target.value.toString(); // Convert input value to string
//     setSearchQuery(inputValue);
//     // setTimeout(()=>{
//       setSearchValue(inputValue)
//     // },5000)
//     setShowDropdown(true);
//   };

//   // const handleOptionClick = (option, index, label, tableIndex, field) => {
//   //   onSelect(option, index, label, tableIndex, field);
//   //   // setSelectedValue(option);
//   //   setSearchQuery("");
//   //   setShowDropdown(false);
//   // };

//   const handleOptionClick = (option, index, label, tableIndex, field) => {
  
//     if (multi) {
//       // Multi-Select Mode
//       setSelectedValue((prev) => {
//         const alreadySelected = prev.some((item) => item._id === option._id);
//         const updatedSelection = alreadySelected
//           ? prev.filter((item) => item._id !== option._id) // Remove if already selected
//           : [...prev , option]; // Add new selection

//         if (onSelect) onSelect(updatedSelection);
//         return updatedSelection;
//       });
//     } else {
//       // Single-Select Mode
      
//       onSelect(option, index, label, tableIndex, field);
//         // setSelectedValue(option);
//         setSearchQuery("");
//         setShowDropdown(false); // Close dropdown after selection in single-select mode
//     }
//   };

//   const handleRemoveValue = (option) => {
//     const updatedSelection = selectedValue.filter((item) => item.value !== option.value);
//     setSelectedValue(updatedSelection);
//     if (onSelect) onSelect(updatedSelection);
//   };

//   const handleRestectChange = (e) => {
//     setSelectedValue(selectedValue);
  
   
//   };

//   const handleaddButtonAction = (e) => {
//     setShowDropdown(false);
//     addButtonAction(error_class);
//   };

//   useEffect(() => {
//     if (id) {
//       const element = document && document?.getElementById(id);

//       const handleMouseDown = (e) => {
//         if (e?.detail > 1) {
//           // f
//           e?.preventDefault();
//         }
//       };

//       if (element) {
//         element.addEventListener("mousedown", handleMouseDown);
//       }

//       return () => {
//         if (element) {
//           element.removeEventListener("mousedown", handleMouseDown);
//         }
//       };
//     }
//   }, [id]);

//   const reqfetchMoreData = () => {
//     fetchMoreData()
//   }

//   const valueFunction = () => {
//     if (selectedValue.code || selectedValue.label || selectedValue?.city?.label) {
//       return [selectedValue.label, selectedValue?.city?.label].filter(Boolean).join(" | ");
//     }
//     return '';
//   }

//   return (
//     <div
//       className={
//         error
//           ? "custom-select-container custom-select_eror"
//           : "custom-select-container"
//       }
//       ref={dropdownRef}
//     >
//       <div className="input-wrapper">
//         <input
//           id={id}
//           type="text"
//           placeholder={placeholder}
          
//           value={
//             multi
//               ? selectedValue?.map((val) => val.name).join(" | ")  // Show selected items as comma-separated values
//               : isCityAddressCode ? valueFunction() : (selectedValue?.label || '') // Show only one selected item
//           }
//           name={name}
//           onChange={handleRestectChange}
//           readOnly={true}
//           disabled={disabled}
//           index={dynamicIndex}
//           onClick={() => setShowDropdown(!showDropdown)}
          
      
//         />
//         {(isClearOption && selectedValue?.label != "All" && selectedValue?.value != "" && selectedValue?.value != null) && (
//           <span className="clear-icon" onClick={isClearHandleChange}>
//             <RxCross2 size={20} color="black" />
//           </span>
//         )}
//       </div>
//       <label className="_fltLabel">
//         <span>
//           {label ? label : flotingLabel}
//           {labelRedStar && <span className="requiredLable"> * </span>}
//         </span>
//       </label>
//       {/* Dropdown Start */}
//       {showDropdown && (
//         <React.Fragment>
//           {openList && (
//             <ul
//               className={
//                 isDropdownTop
//                   ? "custom-dropdown-menu cus-topDrop"
//                   : "custom-dropdown-menu"
//               }
//             >
//               {!disableSearch && (
//                 <li onClick={() => setShowDropdown(!showDropdown)}>
//                   <div
//                     className="dropSearch_bx"
//                     onClick={(e) => e.stopPropagation()}
//                   >
//                     <input
//                       type="text"
//                       placeholder="Search"
//                       onChange={handleInputChange}
//                       autoFocus={true}
//                       value={searchQuery || ""}
//                     />
//                   </div>
//                 </li>
//               )}
//               <li className="mapList_views">

//                 {(filteredOptions.length >4 && enableInfiniteScroll )? (
//                   <InfiniteScroll
//                     dataLength={filteredOptions.length}
//                     next={reqfetchMoreData}
//                     hasMore={hasMore}
//                     loader={<p className="text-center">Loading...</p>}
//                     height={filteredOptions.length < 4 ? filteredOptions.length * 66 : 230}
                  
//                   >


//                     <ul>
//                       {filteredOptions?.length > 0 ? (
//                         filteredOptions?.map((option, index) => (
//                           <React.Fragment key={index}>
//                             <li
                            
//                               className={`_anvRo_locateBx ${multi
//                                 ? selectedValue.some((val) => val._id === option._id)
//                                   ? "_vhlActive"
//                                   : ""
//                                 : selectedValue?.label === option?.label
//                                 ? "_vhlActive"
//                                 : ""
//                               } ${(selectedValue?.value === option?.value && component_class === "vehicle_number_trip") ? '_vhlActive' : ''
//                                 }`}
//                               key={`${option.value}_${index}`}
//                               onClick={() =>
//                                 handleOptionClick(
//                                   option,
//                                   dynamicIndex,
//                                   label,
//                                   tableIndex,
//                                   field
//                                 )
//                               }
//                             >
//                               {label === "Vehicle Number" ? (
//                                 <React.Fragment>
//                                   <div className="anvLrc ">
//                                     <div className="_vhlNumber">{option.label}</div>
//                                     <div className="_vhlOwnType">
//                                       <span
//                                         className={
//                                           option?.vehicle_ownership == 1
//                                             ? "_trkMark _lrDelivered_status"
//                                             : option?.vehicle_ownership == 2
//                                               ? "_trkMark _lrPartyPoint_status"
//                                               : "_trkMark _lrInTransit_status"
//                                         }
//                                       >
//                                         {
//                                           masterData?.vehicle_ownership[
//                                           option?.vehicle_ownership
//                                           ]
//                                         }
//                                       </span>
//                                       {option.lorry_type_id?.lorry_type && option.vehicle_type_id_1?.name
//                                         ? ` | ${option.lorry_type_id.lorry_type} ${option.vehicle_type_id_1.name}`
//                                         : ''}
//                                     </div>
//                                   </div>
//                                   <div className="_vhlStatus">
//                                     <span className="available_status"></span>

//                                     {`${masterData?.vehicle_status[
//                                       option?.vehicle_status
//                                     ]
//                                       }`}
//                                   </div>
//                                 </React.Fragment>
//                               ) : (
//                                 <div className="anvLrc_edit">
//                                   <a>{option.label}</a>

//                                   {onEdit && <div className="po_button_align">
//                                     <button
//                                       className="__edit_btn_po"
//                                       onClick={(e) => {
//                                         e.stopPropagation();
//                                         onEdit(option)
//                                       }}
//                                     >
//                                       <FiEdit />
//                                     </button>
//                                   </div>}
//                                 </div>
//                               )}
//                             </li>
//                           </React.Fragment>
//                         ))
//                       ) : (
//                         <li
//                           className="_anvRo_locateBx"
//                           style={{ fontSize: "13px" }}
//                         >
//                           No Result Found
//                         </li>
//                       )}
//                     </ul>
//                   </InfiniteScroll>) :
//                   <ul>
//                     {filteredOptions?.length > 0 ? (
//                       filteredOptions?.map((option, index) => (
//                         <React.Fragment key={index}>
//                           <li
//                             className={`_anvRo_locateBx 
//                               ${multi
//                                 ? selectedValue.some((val) => val._id === option._id)
//                                   ? "_vhlActive"
//                                   : ""
//                                 : selectedValue?.value === option.value
//                                 ? "_vhlActive"
//                                 : ""
//                               }
//                               ${(selectedValue?.value === option.value && component_class === "vehicle_number_trip") ? '_vhlActive' : ''}`
//                             }
//                             key={`${option.value}_${index}`}
//                             onClick={() =>
//                               handleOptionClick(
//                                 option,
//                                 dynamicIndex,
//                                 label,
//                                 tableIndex,
//                                 field
//                               )
//                             }
//                           >
//                             {label === "Vehicle Number" ? (
//                               <React.Fragment>
//                                 <div className="anvLrc ">
//                                   <div className="_vhlNumber">{option.label}</div>
//                                   <div className="_vhlOwnType">
//                                     <span
//                                       className={
//                                         option?.vehicle_ownership == 1
//                                           ? "_trkMark _lrDelivered_status"
//                                           : option?.vehicle_ownership == 2
//                                             ? "_trkMark _lrPartyPoint_status"
//                                             : "_trkMark _lrInTransit_status"
//                                       }
//                                     >
//                                       {
//                                         masterData?.vehicle_ownership[
//                                         option?.vehicle_ownership
//                                         ]
//                                       }
//                                     </span>
//                                     {` | ${option.lorry_type_id?.lorry_type} ${option.vehicle_type_id_1?.name}`}
//                                   </div>
//                                 </div>
//                                 <div className="_vhlStatus">
//                                   <span className="available_status"></span>

//                                   {`${masterData?.vehicle_status[
//                                     option?.vehicle_status
//                                   ]
//                                     }`}
//                                 </div>
//                               </React.Fragment>
//                             ) : (
//                               <div className="anvLrc_edit">
//                                 <a>{optionShowCityState ? option.cityStateLabel : option.label}</a>

//                                 {onEdit && <div className="po_button_align">
//                                   <button
//                                     className="__edit_btn_po"
//                                     onClick={(e) => {
//                                       e.stopPropagation();
//                                       onEdit(option)
//                                     }}
//                                   >
//                                     <FiEdit />
//                                   </button>
//                                 </div>}
//                               </div>
//                             )}
//                           </li>
//                         </React.Fragment>
//                       ))
//                     ) : (
//                       <li
//                         className="_anvRo_locateBx"
//                         style={{ fontSize: "13px" }}
//                       >
//                         No Result Found
//                       </li>
//                     )}
//                   </ul>}


//               </li>
              
//               {isAddButton ? (
//                 <li className="mt-1 _lineDrp anvLrc">
//                   <button
//                     className="_addNew_cdmBtn"
//                     onClick={handleaddButtonAction}
//                   >
//                     <svg
//                       xmlns="http://www.w3.org/2000/svg"
//                       width="16"
//                       height="16"
//                       viewBox="0 0 18 18"
//                       fill="none"
//                     >
//                       <path
//                         d="M8.61539 0C6.33902 0.0276205 4.16368 0.944178 2.55393 2.55393C0.944178 4.16368 0.0276205 6.33902 0 8.61539C0.0276205 10.8917 0.944178 13.0671 2.55393 14.6768C4.16368 16.2866 6.33902 17.2031 8.61539 17.2308C10.8917 17.2031 13.0671 16.2866 14.6768 14.6768C16.2866 13.0671 17.2031 10.8917 17.2308 8.61539C17.2031 6.33902 16.2866 4.16368 14.6768 2.55393C13.0671 0.944178 10.8917 0.0276205 8.61539 0ZM13.5385 9.23077H9.23077V13.5385H8V9.23077H3.69231V8H8V3.69231H9.23077V8H13.5385V9.23077Z"
//                         fill="#1956F6"
//                       />
//                     </svg>
//                     Add New
//                   </button>
//                 </li>
//               ) : (
//                 <></>
//               )}
//             </ul>
//           )}
//         </React.Fragment>
//       )}
//       {/* Dropdown End */}
//       {errorShow && <>
//         {error && (
//           <span className={"input_drop_error" + error_class}>{error}</span>
//         )}
//       </>}
//     </div>
//   );
// };

// export default CustomSelect;
